import { BlastEvent, SimulationConfig } from '../../../types';
import { getRadiusAtAngle } from '../../../break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const ConfettiAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for(let i=0; i<20; i++){
    const ang = (i/20) * Math.PI * 2 + progress * 5;
    const dst = e.maxRadius + progress * 200;
    const r = getRadiusAtAngle(ang, e, dst);
    const cx = e.pos.x + Math.cos(ang) * r;
    const cy = e.pos.y + Math.sin(ang) * r;
    ctx.save(); ctx.translate(cx, cy); ctx.rotate(progress * 10);
    ctx.fillRect(-5,-2,10,4); ctx.restore();
  }
};

registerBlastAnimation('CONFETTI', ConfettiAnimation);
